/**
 * Ambera search panel: hangs the theme's search dialog from the header's bottom edge.
 *
 * The dialog itself stays the theme's (`dialog-component` + `predictive-search-component`); this
 * only keeps `--ambera-search-top` on `#search-modal` in step with where the header ends, so the
 * panel and its dimmed backdrop start below it. On mobile the panel covers the header (top 0).
 */
const modal = document.getElementById('search-modal');

if (modal && modal.classList.contains('search-modal--ambera') && !modal.dataset.amberaSearchReady) {
  modal.dataset.amberaSearchReady = '';

  const desktop = window.matchMedia('(min-width: 750px)');

  const update = () => {
    let top = 0;

    if (desktop.matches) {
      const header = document.getElementById('header-component');
      top = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
    }

    modal.style.setProperty('--ambera-search-top', `${top}px`);
  };

  // The search button opens the dialog in the next animation frame, so measuring on the click
  // (capture phase) places the panel before its first paint.
  document.addEventListener(
    'click',
    (event) => {
      if (event.target instanceof Element && event.target.closest('search-button')) update();
    },
    true
  );
  modal.addEventListener('dialog:open', update);
  window.addEventListener('resize', update, { passive: true });
  update();
}
